module.exports = __webpack_public_path__ + "img/shopping-bag.6fea85af.svg";